import { render, staticRenderFns } from "./taskDetails.vue?vue&type=template&id=50cc1538&"
import script from "./taskDetails.vue?vue&type=script&lang=js&"
export * from "./taskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports